import React, { FC } from 'react';
import { useLandingPageContext } from 'context/LandingPageContext';
import MinimalProductPrice from 'components/Common/Prices/MinimalProductPrice/MinimalProductPrice';
import { AppBundle } from 'api/optimalprint-sdk.d';
import styles from './SquareLpShopifyCatalogItem.module.scss';
import PricesSize from '../../../Common/Prices/ProductPrice/types';

export interface MediumBannerProps {
  imageUrl: string;
  imageUrlMobile: string;
  referenceLabel: string;
  referenceUrl: string;
  label?: string;
  priceFormatted?: string;
  abstractProduct: AppBundle.Api.Entity.App.V1.IAbstractProduct;
}

const SquareLpShopifyCatalogItem: FC<MediumBannerProps> = ({
  imageUrl,
  imageUrlMobile,
  referenceUrl,
  referenceLabel,
  abstractProduct,
}) => {
  const { isDesktopDevice } = useLandingPageContext();

  return (
    <div className={styles.container}>
      <a href={referenceUrl} className={styles.squareBanner}>
        <img src={isDesktopDevice ? imageUrl : imageUrlMobile} alt="" />
      </a>
      {referenceLabel && (
        <a href={referenceUrl} className={styles.label}>
          {referenceLabel}
        </a>
      )}
      <div className={styles.lpCatalogItemPrice}>
        <MinimalProductPrice
          categoryId={abstractProduct.categoryId}
          quantity={1}
          product={abstractProduct}
          size={PricesSize.sm}
          theme="landing"
        />
      </div>
    </div>
  );
};

export default SquareLpShopifyCatalogItem;
